import { createAction, props } from '@ngrx/store';
import { CartItem } from 'src/app/feature/cart/models/cart-item.model';
import { CartSummaryResponse } from 'src/app/feature/cart/models/cart-summary-response.model';

export enum CartActions {
	GetNewCartIdRequested = '[Booking Modify] Get New Cart ID Requested',
	GetNewCartIDReceived = '[Cart Effects] Get New Cart ID Received',
	GetNewCartIDFailed = '[Cart Effects] Get New Cart ID Failed',
	RemoveCartInfo = '[Booking Modify] Remove Cart ID and Cart Key',
	GetDynamicPricingAdjustmentRequested = '[Booking Modify] Get Dynamic Pricing Adjustment Requested',
	GetDynamicPricingAdjustmentFailed = '[Booking Modify] Get Dynamic Pricing Adjustment Failed',
	GetDynamicPricingAdjustmentSuccess = '[Booking Modify] Get Dynamic Pricing Adjustment Success',
	AddCartItemRequested = '[Booking Modify] Add Cart Item Requested',
	AddCartItemFailed = '[Booking Modify] Add Cart Item Failed',
	AddCartItemSuccess = '[Booking Modify] Add Cart Item Success',
	UpdateCartItemsRequested = '[Booking Modify] Update Cart Items Requested',
	UpdateCartItemsFailed = '[Booking Modify] Update Cart Items Failed',
	UpdateCartItemsSuccess = '[Booking Modify] Update Cart Items Success',
	GetCartSummaryRequested = '[Upgrade Summary] Get Cart Summary Requested',
	GetCartSummaryFailed = '[Upgrade Summary] Get Cart Summary Failed',
	GetCartSummarySuccess = '[Upgrade Summary] Get Cart Summary Success',
}

/**
 * Used to create a new cartId when a new purchase flow is initiated
 */
export const getNewCartIDRequested = createAction(
	CartActions.GetNewCartIdRequested,
	props<{
		merchant_id: string;
	}>()
);

/**
 * Response from successful GetNewCartID request
 */
export const getNewCartIDReceived = createAction(
	CartActions.GetNewCartIDReceived,
	props<{
		cartId: number;
		cartKey: number;
	}>()
);

/**
 * Response from failed GetNewCartID request
 */
export const getNewCartIDFailed = createAction(CartActions.GetNewCartIDFailed);

/**
 * Remove cart info from the state
 */
export const removeCartInfo = createAction(CartActions.RemoveCartInfo);

/**
 * Called to hold dynamic pricing disount to the cart
 * When calling getCartSummary/Purchase it will use the saved discount
 */
export const getDynamicPricingAdjustmentRequested = createAction(
	CartActions.GetDynamicPricingAdjustmentRequested,
	props<{
		cart_id: number;
		cart_key: number;
		merchant_id: string;
		package_id: string;
		customer_type: string;
		start_date: string;
		start_time: string;
	}>()
);

/**
 * GetDynamicPricingAdjustment failed
 */
export const getDynamicPricingAdjustmentFailed = createAction(CartActions.GetDynamicPricingAdjustmentFailed);

/**
 * Response from successful GetDynamicPricingAdjustment request
 */
export const GetDynamicPricingAdjustmentSuccess = createAction(CartActions.GetDynamicPricingAdjustmentSuccess);

/**
 * Used to add an item to the cart
 */
export const addCartItemRequested = createAction(
	CartActions.AddCartItemRequested,
	props<{
		cart_id: number;
		cart_key: number;
		merchant_id: string;
		ITEMS: {
			ITEM: CartItem[];
		}[];
	}>()
);

/**
 * AddCartItem failed
 */
export const addCartItemFailed = createAction(CartActions.AddCartItemFailed);

/**
 * AddCartItem succeeded
 */
export const addCartItemSuccess = createAction(CartActions.AddCartItemSuccess);

/**
 * Remove items from cart because modification flow was canceled
 */
export const updateCartItemsRequested = createAction(
	CartActions.UpdateCartItemsRequested,
	props<{
		cart_id: number;
		cart_key: number;
		merchant_id: string;
		ITEMS: {
			ITEM: CartItem[];
		}[];
	}>()
);

/**
 * UpdateCartItems failed
 */
export const updateCartItemsFailed = createAction(CartActions.UpdateCartItemsFailed);

/**
 * UpdateCartItems succeeded
 */
export const updateCartItemsSuccess = createAction(CartActions.UpdateCartItemsSuccess);

/**
 * GetCartSummary requested
 */
export const getCartSummaryRequested = createAction(
	CartActions.GetCartSummaryRequested,
	props<{
		cart_id: number;
		cart_key: number;
		merchant_id: string;
	}>()
);

/**
 * GetCartSummary failed
 */
export const getCartSummaryFailed = createAction(CartActions.GetCartSummaryFailed);

/**
 * GetCartSummary succeeded
 */
export const getCartSummarySuccess = createAction(
	CartActions.GetCartSummarySuccess,
	props<{
		summary: CartSummaryResponse;
	}>()
);
